import { AbstractControl, ValidatorFn, Validators } from '@angular/forms'

export type AppointmentCreateRequiredFieldId =
  | 'patient'
  | 'facility'
  | 'selectedProducts'
  | 'startAt'
  | 'duration'
  | 'notes'
  | 'statusDescription'
  | 'priority'
  | 'referrer'
  | 'provider'
  | 'room'
  | 'equipment'
  | 'account'

export type PatientCreateRequiredFieldId =
  | 'prefixName'
  | 'givenName'
  | 'nickName'
  | 'middleName'
  | 'familyName'
  | 'suffixName'
  | 'maidenName'
  | 'eid'
  | 'phoneNumber'
  | 'email'
  | 'sex'
  | 'contactMethod'
  | 'language'
  | 'preferredFacilityId'
  | 'ssn'
  | 'dob'
  | 'address'
  | 'religion'
  | 'maritalStatus'
  | 'race'
  | 'ethnicity'
  | 'guarantorGivenName'
  | 'guarantorFamilyName'
  | 'guarantorPhoneNumber'
  | 'guarantorEmail'
  | 'guarantorRelationship'
  | 'guarantorSex'
  | 'guarantorDob'
  | 'emergencyContactGivenName'
  | 'emergencyContactFamilyName'
  | 'emergencyContactPhoneNumber'
  | 'emergencyContactEmail'
  | 'emergencyContactRelationship'
  | 'emergencyContactSex'
  | 'emergencyContactDob'
  | 'employerName'
  | 'employerPhone'
  | 'employerAddress'

export const APPOINTMENT_CREATE_REQUIRED_FIELD_OPTIONS: Array<{ value: AppointmentCreateRequiredFieldId, label: string }> = [
  { value: 'patient', label: 'settings.custom-fields.required-create-fields.options.patient' },
  { value: 'facility', label: 'settings.custom-fields.required-create-fields.options.facility' },
  { value: 'selectedProducts', label: 'settings.custom-fields.required-create-fields.options.selectedProducts' },
  { value: 'startAt', label: 'settings.custom-fields.required-create-fields.options.startAt' },
  { value: 'duration', label: 'settings.custom-fields.required-create-fields.options.duration' },
  { value: 'notes', label: 'settings.custom-fields.required-create-fields.options.notes' },
  { value: 'statusDescription', label: 'settings.custom-fields.required-create-fields.options.statusDescription' },
  { value: 'priority', label: 'settings.custom-fields.required-create-fields.options.priority' },
  { value: 'referrer', label: 'settings.custom-fields.required-create-fields.options.referrer' },
  { value: 'provider', label: 'settings.custom-fields.required-create-fields.options.provider' },
  { value: 'room', label: 'settings.custom-fields.required-create-fields.options.room' },
  { value: 'equipment', label: 'settings.custom-fields.required-create-fields.options.equipment' },
  { value: 'account', label: 'settings.custom-fields.required-create-fields.options.account' },
]

export const PATIENT_CREATE_REQUIRED_FIELD_OPTIONS: Array<{ value: PatientCreateRequiredFieldId, label: string }> = [
  { value: 'prefixName', label: 'settings.custom-fields.required-create-fields.options.prefixName' },
  { value: 'givenName', label: 'settings.custom-fields.required-create-fields.options.givenName' },
  { value: 'nickName', label: 'settings.custom-fields.required-create-fields.options.nickName' },
  { value: 'middleName', label: 'settings.custom-fields.required-create-fields.options.middleName' },
  { value: 'familyName', label: 'settings.custom-fields.required-create-fields.options.familyName' },
  { value: 'suffixName', label: 'settings.custom-fields.required-create-fields.options.suffixName' },
  { value: 'maidenName', label: 'settings.custom-fields.required-create-fields.options.maidenName' },
  { value: 'eid', label: 'settings.custom-fields.required-create-fields.options.eid' },
  { value: 'phoneNumber', label: 'settings.custom-fields.required-create-fields.options.phoneNumber' },
  { value: 'email', label: 'settings.custom-fields.required-create-fields.options.email' },
  { value: 'sex', label: 'settings.custom-fields.required-create-fields.options.sex' },
  { value: 'contactMethod', label: 'settings.custom-fields.required-create-fields.options.contactMethod' },
  { value: 'language', label: 'settings.custom-fields.required-create-fields.options.language' },
  { value: 'preferredFacilityId', label: 'settings.custom-fields.required-create-fields.options.preferredFacilityId' },
  { value: 'ssn', label: 'settings.custom-fields.required-create-fields.options.ssn' },
  { value: 'dob', label: 'settings.custom-fields.required-create-fields.options.dob' },
  { value: 'address', label: 'settings.custom-fields.required-create-fields.options.address' },
  { value: 'religion', label: 'settings.custom-fields.required-create-fields.options.religion' },
  { value: 'maritalStatus', label: 'settings.custom-fields.required-create-fields.options.maritalStatus' },
  { value: 'race', label: 'settings.custom-fields.required-create-fields.options.race' },
  { value: 'ethnicity', label: 'settings.custom-fields.required-create-fields.options.ethnicity' },
  { value: 'guarantorGivenName', label: 'settings.custom-fields.required-create-fields.options.guarantorGivenName' },
  { value: 'guarantorFamilyName', label: 'settings.custom-fields.required-create-fields.options.guarantorFamilyName' },
  { value: 'guarantorPhoneNumber', label: 'settings.custom-fields.required-create-fields.options.guarantorPhoneNumber' },
  { value: 'guarantorEmail', label: 'settings.custom-fields.required-create-fields.options.guarantorEmail' },
  { value: 'guarantorRelationship', label: 'settings.custom-fields.required-create-fields.options.guarantorRelationship' },
  { value: 'guarantorSex', label: 'settings.custom-fields.required-create-fields.options.guarantorSex' },
  { value: 'guarantorDob', label: 'settings.custom-fields.required-create-fields.options.guarantorDob' },
  { value: 'emergencyContactGivenName', label: 'settings.custom-fields.required-create-fields.options.emergencyContactGivenName' },
  { value: 'emergencyContactFamilyName', label: 'settings.custom-fields.required-create-fields.options.emergencyContactFamilyName' },
  { value: 'emergencyContactPhoneNumber', label: 'settings.custom-fields.required-create-fields.options.emergencyContactPhoneNumber' },
  { value: 'emergencyContactEmail', label: 'settings.custom-fields.required-create-fields.options.emergencyContactEmail' },
  { value: 'emergencyContactRelationship', label: 'settings.custom-fields.required-create-fields.options.emergencyContactRelationship' },
  { value: 'emergencyContactSex', label: 'settings.custom-fields.required-create-fields.options.emergencyContactSex' },
  { value: 'emergencyContactDob', label: 'settings.custom-fields.required-create-fields.options.emergencyContactDob' },
  { value: 'employerName', label: 'settings.custom-fields.required-create-fields.options.employerName' },
  { value: 'employerPhone', label: 'settings.custom-fields.required-create-fields.options.employerPhone' },
  { value: 'employerAddress', label: 'settings.custom-fields.required-create-fields.options.employerAddress' },
]

export const DEFAULT_APPOINTMENT_CREATE_REQUIRED_FIELDS: AppointmentCreateRequiredFieldId[] = [
  'patient',
  'facility',
  'statusDescription',
]

export const DEFAULT_PATIENT_CREATE_REQUIRED_FIELDS: PatientCreateRequiredFieldId[] = [
  'givenName',
  'familyName',
  'dob',
]

/**
 * Applies required field validators to form controls based on a set of required field names.
 * Base validators (if provided) are preserved, and Validators.required is added conditionally.
 *
 * @param requiredFields Set of field names that should be required
 * @param controls Form group controls to apply validators to
 * @param baseValidators Optional map of field-specific base validators to apply to all controls
 */
export function applyRequiredFieldValidators(
  requiredFields: ReadonlySet<string>,
  controls: Record<string, AbstractControl>,
  baseValidators?: Partial<Record<string, ValidatorFn[]>>,
): void {
  Object.keys(controls).forEach((controlName) => {
    const control = controls[controlName]

    if (!baseValidators) {
      if (requiredFields.has(controlName)) {
        control.addValidators(Validators.required)
      } else {
        control.removeValidators(Validators.required)
      }
      control.updateValueAndValidity({ emitEvent: false })
      return
    }

    const validators = [...(baseValidators[controlName] || [])]

    if (requiredFields.has(controlName)) {
      validators.unshift(Validators.required)
    }

    control.setValidators(validators)
    control.updateValueAndValidity({ emitEvent: false })
  })
}
